// DS6.7.1
import React from 'react';
import classnames from 'classnames';
import Tag from './Tag';
import RemovableTag from './RemovableTag';
import type { TagType } from './types';

import { sanitizeHref } from '@wix/da-url';

import s from './TagList.scss';

interface Props {
  tags: (TagType | null)[];
  size?: 'small' | 'medium';
  multiline?: boolean;
  /** truncate tag text w/ ellipsis */
  isTruncated?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const TagList = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { tags, size = 'medium', multiline, isTruncated, className, children } = props;
  return (
    <div
      className={classnames(s['root'], s[`size-${size}`], !multiline && s['scrollable'], className)}
      ref={ref}
    >
      {(tags.filter(t => t) as TagType[]).map(
        ({
          tagname,
          href,
          isRemovable,
          isRecommended,
          isSelected,
          biData,
          className: tagClassName,
          onClick,
        }) => {
          const TagItem = isRemovable ? RemovableTag : Tag;
          return (
            <TagItem
              key={tagname}
              data-tagname={tagname}
              title={tagname}
              size={size}
              href={sanitizeHref(href)}
              isSelected={isSelected}
              onClick={onClick}
              biData={biData}
              isTruncated={isTruncated}
              isRecommended={isRecommended}
              className={classnames(s['tag-item'], tagClassName)}
            >
              {tagname}
            </TagItem>
          );
        }
      )}
      {children}
    </div>
  );
});
TagList.displayName = 'TagList';

export default TagList;
